import React from 'react';
import {View, StyleSheet, ScrollView, Pressable} from 'react-native';
import {corner_radius, spacing} from 'theme/Units';
import colors from 'theme/Colors';
import {Text} from 'ui-kits';

type propType = Readonly<{
  name: string;
  description: string;
  id: string;
  goToProjectDashboard: (id: string,name:string) => void;
}>;
export function AssignedProjectCard(props: propType) {
  const {description, id, name, goToProjectDashboard} = props;
  return (
    <View style={styles.container}>
      <Text style={styles.projectId}>{id}</Text>
      <Pressable onPress={() => goToProjectDashboard(id, name)}>
        <Text style={styles.name}>{name}</Text>
      </Pressable>
      <ScrollView showsVerticalScrollIndicator={false}>
        <Text style={styles.description}>{description}</Text>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: spacing['4'],
    borderWidth: 1,
    borderColor: colors.palette.neutralN300,
    backgroundColor: colors.palette.white,
    height: 225,
    width: 300,
    borderRadius: corner_radius['rounded-md'],
    gap: spacing['2'],
  },
  name: {
    fontSize: 20,
    fontWeight: 600,
  },
  description: {
    fontWeight: 500,
    fontSize: 14,
    color: colors.palette.secondaryBlack5,
  },
  projectId: {
    color: colors.palette.neutralN500,
    fontWeight: 500,
    fontSize: 14,
  },
});
